import { Decoder, field, succeed } from 'jsonous';
import { resourceDecoder } from '../../../../../../Resource/Decoders';
import { stringOptionsContentDecoder } from '../../../../../GenericSortFilter/Decoders';
import { DeepLinksOptions, DeepLinksOptionsResource } from './Types';

const participantsOptionsDecoder: Decoder<DeepLinksOptions> = succeed({})
  .assign('deliveryChannels', field('delivery_channels', stringOptionsContentDecoder))
  .assign('programTypes', field('program_types', stringOptionsContentDecoder))
  .assign('licenses', field('licenses', stringOptionsContentDecoder));

export const deepLinksOptionsResourceDecoder: Decoder<DeepLinksOptionsResource> = resourceDecoder(
  participantsOptionsDecoder,
);
